import { compose } from 'recompose';
import { connect } from 'react-redux';
import { addProps } from 'utils/recompose';
import combineSelectors from 'utils/combineSelectors';

const mapStateToProps = combineSelectors({});

const cost = ({ optionKey, designPackage }) =>
  designPackage[optionKey].upcharge;
const optionName = ({ optionKey }) =>
  optionKey
    .replace('Option', '')
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, function(str) {
      return str.toUpperCase();
    });
const description = ({ optionKey, designPackage }) =>
  designPackage[optionKey].description;
const optionCode = ({ optionKey, designPackage }) =>
  designPackage[optionKey].id;
const url = ({ optionKey, designPackage }) =>
  designPackage[optionKey].iconImgUrl;

export default compose(
  connect(mapStateToProps, {}),
  addProps({
    cost,
    description,
    optionCode,
    optionName,
    url,
  }),
);
